<template lang="pug">
  .page__items
    .page__item(data-id="main")
      Main
    .page__item(data-id="contacts")
      Contacts
    .page__item(data-id="about")
      About
    .page__item(data-id="comment")
      Comment
    .page__item(data-id="menu")
      Menu
    .page__item(data-id="tour")
      Tour
    .page__item(data-id="photo-reports")
      PhotoReports
    .page__item(data-id="photo-report")
      PhotoReport
    .page__item(data-id="page-404")
      Page404
    .page__item(data-id="announcements")
      Announcements
    .page__item(data-id="announcement")
      Announcement
    .page__item(data-id="policy")
      PrivacyPolicy
    .page__item(data-id="cart")
      Cart
    .page__item(data-id="card-payment")
      CardPayment
    .page__item(data-id="company-details")
      CompanyDetails

</template>

<script>
  import EventBus from '@/eventBus';

  import Main from '@/views/Main';
  import Contacts from '@/views/Contacts';
  import About from '@/views/About';
  import Comment from '@/views/Comment';
  import Menu from '@/views/Menu';
  import Tour from '@/views/Tour';
  import PhotoReports from '@/views/PhotoReports';
  import PhotoReport from '@/components/common/photoReport/PhotoReport';
  import Page404 from '@/views/Page404';
  import Announcements from '@/views/Announcements';
  import Announcement from '@/components/common/announcement/Announcement';
  import PrivacyPolicy from '@/views/PrivacyPolicy';
  import Cart from '@/views/Cart';
  import CardPayment from '@/views/CardPayment';
  import CompanyDetails from '@/views/CompanyDetails';
  import router from "../../router";
  import vueScrollBehavior from "../../router";

  export default {
    components: {
      About,
      Main,
      Contacts,
      Comment,
      Menu,
      Tour,
      PhotoReports,
      PhotoReport,
      Page404,
      Announcements,
      Announcement,
      PrivacyPolicy,
      Cart,
      CardPayment,
      CompanyDetails
    },
    data() {
        return {
            swiper: null
        }
    },

    // Первый заход на страницу & для роутов типа /catalog/:id
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.content = null;
        if(to.name !== 'MenuNested') {
            $('.page__item').removeClass('page__item--anima');
        }
        $('.page__view').animate({
          scrollTop: 0
        }, 0);
        // экземпляр компонента доступен как `vm`
        let params = vm.getParams(to, from);
        params.action = 'enter';
        setTimeout(() => {
            if(vm.swiper) {
                vm.swiper.destroy(true, true);
            }

            EventBus.$emit(params.event, params);
            $('.samedia').addClass('samedia--hide');
            $('.footer').addClass('footer--hide');
            // EventBus.$emit('setMenuTopActiveClass', to.path, from.path);
        }, 200);
      })
    },

    // Навигация по ссылкам
    beforeRouteUpdate(to, from, next) {
      if(to.name == 'Cart' || to.name == 'CartStep') {
        let params = this.getParams(to, from);
        EventBus.$emit(params.event, params);
        EventBus.$emit('setMenuTopActiveClass', to.path, from.path);
        next();
        return false;
      }

      this.content = null;
      if(to.name !== 'MenuNested') {
        $('.page__item').removeClass('page__item--anima');
      }
      if (from.name === 'Menu') {
          EventBus.$emit('pushMenuPage');
      }
      $('.page__view').animate({
        scrollTop: 0
      }, 0);
      let params = this.getParams(to, from);
      params.action = 'update';

      setTimeout(() => {
          if (this.swiper) {
              this.swiper.destroy(true, true);
          }

          EventBus.$emit(params.event, params);
          $('.samedia').addClass('samedia--hide');
          $('.footer').addClass('footer--hide');
          if (from.path == '/kontakty') {
              $('.contacts__message').addClass('contacts__message--hide');
              $('.contacts__form').removeClass('contacts__form--hide');
          }
          // EventBus.$emit('setMenuTopActiveClass', to.path, from.path);
          next();
      }, 200);
    },

    created() {
        EventBus.$on('swiperInit', (swiper) => {
            this.swiper = swiper;
        });
    },

    mounted() {
    },

    methods: {
      getParams(route, from) {
        let path = route.path;
        let url  = route.path || '';

        let routeName = route.name || '';

        let event  = '';
        let params = {};

        if(path === '/') {
          event = 'loadMainPage';
        }
        else if(path === '/kontakty') {
          event = 'loadContactsPage';
        }
        else if(path === '/o-zavedenii') {
            event = 'loadAboutPage';
        }
        else if(path === '/otzyvy') {
            event = 'loadCommentPage';
        }
        else if(path === '/menyu') {
            event = 'loadMenuPage';
        }
        else if(path === '/3d-tur') {
            event = 'loadTourPage';
        }
        else if(path === '/fotootchyoty') {
            event = 'loadPhotoReportsPage';
        }
        else if(path === '/anonsy') {
            event = 'loadAnnouncementsPage';
        }
        else if(path === '/politika-konfidencialnosti') {
            event = 'loadPolicyPage';
        }
        else if(path === '/oplata-po-karte-sberbanka') {
            event = 'loadCardPaymentPage';
        }
        else if(path === '/rekvizity-kompanii') {
          event = 'loadCompanyDetailsPage';
        }
        else {
          event = 'load404Page';
        }

        if(routeName === 'Cart' || routeName === 'CartStep') {
          event = 'loadCartPage';
          params.params = route.params || {};
        } else {
          EventBus.$emit('resetFirstReq');
        }

        if(routeName === 'MenuNested') {
          event = 'loadMenuCategoryContent';
          params.type = route.params.type || '';
        }

        if(routeName === 'PhotoReport') {
          event = 'loadPhotoReportPage';
          params.type = route.params.type || '';
        }

        if(routeName === 'Announcement') {
          event = 'loadAnnouncementPage';
          params.type = route.params.type || '';
        }

        params.event = event || '';
        params.url = url;
        params.from = from.path;

        return params;
      }
    }
  }
</script>
